import type { SessionRepairStatus } from './types';

export const FETCH_CONCURRENCY = 4;
export const LIST_PAGE_SIZE = 25;

export const SESSION_REPAIR_STATUS_LABELS: Record<SessionRepairStatus, string> =
  {
    no_hr_data: 'Senza dati HR',
    repaired_perfect: 'Perfetta (riparata)',
    perfect: 'Perfetta',
    needs_repair: 'Da riparare',
    not_analyzed: 'Non analizzata',
    analyzing: 'Analisi in corso…',
    analysis_failed: 'Analisi fallita',
  };

export const SESSION_REPAIR_STATUS_COLORS: Record<SessionRepairStatus, string> =
  {
    no_hr_data: 'gray',
    repaired_perfect: 'blue',
    perfect: 'teal',
    needs_repair: 'orange',
    not_analyzed: 'gray',
    analyzing: 'gray',
    analysis_failed: 'red',
  };
